module.exports = __webpack_public_path__ + "img/crotone.5e9707a0.png";